export const getTemplateData = state => state.templates.template;
export const templateIsFetching = state => state.templates.loading;